import classNames from 'clsx';
import React, { useEffect } from 'react';

import usePrevious from '@swf/core/hooks/usePrevious';
import { Image, Loader, useGetCurrentClub, useGetPlayersBasedOnStatus } from '@swf/poker';

import styles from './ClubMemberAvatars.scss';

interface Props {
  clubId: number;
  className?: string;
}

const ClubMemberAvatars: React.FC<Props> = ({ clubId, className }) => {
  const {
    loading,
    response: { data },
    handleGetPlayers
  } = useGetPlayersBasedOnStatus({ clubId });
  const { nbMembers } = useGetCurrentClub(`${clubId}`);
  const remaining = Number(nbMembers) - data.length;
  const prevClubId = usePrevious(clubId);

  useEffect(() => {
    handleGetPlayers({ clubId, statuses: ['HG_MEMBERSHIP_STATUS_APPROVED'], limit: 4 });
  }, [clubId, handleGetPlayers]);

  return (
    <div className={classNames(styles.container, className)}>
      <Loader loading={loading || clubId !== prevClubId}>
        <div className={styles.avatarContainer}>
          {data.length &&
            data.map(({ avatar, userId }, index) => (
              <div
                className={styles.avatar}
                key={userId}
                style={{ marginLeft: index === 0 ? 0 : -10, zIndex: data.length - index }}
              >
                {avatar ? <Image imageByteArray={avatar} /> : `${userId}`.slice(0, 1)}
              </div>
            ))}
          {remaining > 0 && <div className={styles.remaining}>+{remaining}</div>}
        </div>
      </Loader>
    </div>
  );
};

export default ClubMemberAvatars;
